import * as React from 'react';
import { setInnerHtml } from 'sos-common/js/utils/helpers';
import { makeTranslator } from 'sos-common/js/utils/translations';
import { shortuid } from 'sos-common/js/utils/guid';
import { SelectBoxOption } from 'sos-common/js/components/FormControls/SelectBox';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { InputError } from 'sos-common/js/components/InputError/InputError';
import { doPost } from 'sos-eservice-common/js/services';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import YrkeSection from './FormSections/yrke.section';
import SpecialistkompetensSection from './FormSections/specialistkompetens.section';
import BetalningSection from './FormSections/betalning.section';
import UtbildningSection from './FormSections/utbildning.section';
import DokumentSection from './FormSections/dokument.section';
import PersonuppgifterSection from './FormSections/personuppgifter.section';
import GranskningAvUtbildningSection from './FormSections/granskningavutbildning.section';
import { FormFieldFile, FormField } from 'sos-common/js/commonTypes/formField.types';
import { FileState } from 'sos-common/js/commonTypes/fileupload.types';
import { ResourceItem } from 'sos-common/js/commonTypes/resourceItem';
import {
  TypeOfAnsokan,
  YrkeKostnad,
  BUSINESS_RULES,
  OpenWebAnsokanEpiTexts,
  SectionClass,
  OpenWebAnsokanInfoBubbles,
  FieldName,
  FormType,
  OutSideEuEesType,
} from './PublicForm.types';
import { Yrke } from '../AnsokanForms/LegAnsokanForm.types';
import { EpiserverProperty } from 'sos-common/js/utils/episerver.property';
import SpecialistsjukskoterskaSection from './FormSections/specialistsjukskoterska.section';
import { DocumentFetcher, GetDocumentModelParams } from './DocumentModel/document.model.fetcher';
import { DocumentModel } from './DocumentModel/document.model.types';
import _ from 'lodash';
import { IGoogleReCaptchaConsumerProps } from 'react-google-recaptcha-v3';
import { DialogueError } from 'sos-common/js/components/DialogueError/DialogueError';
import { getDialogueByResponse } from '../../helpers/webform.dialogue.helper';
import { MailType, MailTypeFieldName } from '../../models/email.types';
import LoadingSpinner from 'sos-common/js/components/LoadingSpinner/LoadingSpinner';
import AttentionBox from 'sos-common/js/components/AttentionBox/Attentionbox';
import { MultiSelectItem } from '../AnsokanForms/Specialistbevis/SpecialistbevisAnsokanForm.types';
export interface IPublicFormProps {
  openWebAnsokanEpiTexts: OpenWebAnsokanEpiTexts;
  isInEditMode: boolean;
  antiForgery?: string;
  clientKey: string;
  translation: ResourceItem[];
  heading: string;
  typeOfAnsokan: TypeOfAnsokan;
  hasWorked3YearsInEUEES: boolean;
  predefinedYrke?: Yrke;
  yrkeKostnader: YrkeKostnad[];
  contentId: number;
  googleReCaptchaProps?: IGoogleReCaptchaConsumerProps | undefined;
  openWebAnsokanInfoBubbles: OpenWebAnsokanInfoBubbles;
  maxTotalSizeInBytes: number;
  redirectPage: string;
  maxIndividualFileSizeInBytes: number;
  formLanguage: string;
  countryList: string[];
  acceptedFileTypes: string[];
  outSideEuEesType: OutSideEuEesType;
}

export interface IPublicFormState {
  formData: Map<string, string>;
  activeYrke: Yrke;
  hasErrors: boolean;
  documents: DocumentModel[];
  specialistCostInformation: string;
  isErrorDialogOpen: boolean;
  apiLogId?: string;
  samtycker: boolean;
  showSpinner: boolean;
  submitButtonIsClicked?: boolean;
  isFormDirty: boolean;
}

let Translate: (key: string, defaultValue?: string) => string;
const ContentIdFieldName = '__contentId';
const LanguageFIeldName = '__languageId';
const CaptchaFieldName = '__captchaToken';
const OutsideEuEesTypeFieldName = 'outsideeueestype';

export class PublicForm extends React.Component<IPublicFormProps, IPublicFormState> {
  private _documentFetcher: DocumentFetcher;
  private _documentFetcherParams: GetDocumentModelParams;
  private _formRef: React.RefObject<HTMLFormElement>;
  private _errorId: string;
  private _yrkeSectionRef: React.RefObject<YrkeSection>;
  private _specialistsjukskoterskaSectionRef: React.RefObject<SpecialistsjukskoterskaSection>;
  private _specialistkompetensSectionRef: React.RefObject<SpecialistkompetensSection>;
  private _betalningSectionRef: React.RefObject<BetalningSection>;
  private _utbildningSectionRef: React.RefObject<UtbildningSection>;
  private _dokumentSectionRef: React.RefObject<DokumentSection>;
  private _personuppgifterSectionRef: React.RefObject<PersonuppgifterSection>;
  private _granskningAvUtbildningSectionRef: React.RefObject<GranskningAvUtbildningSection>;
  private _sectionRefList: React.RefObject<SectionClass<any, any>>[];
  private _isSpecialistClicked: boolean;

  constructor(props: IPublicFormProps) {
    super(props);
    Translate = makeTranslator(props.translation);
    this._formRef = React.createRef();
    this._errorId = shortuid();
    this._sectionRefList = [
      (this._yrkeSectionRef = React.createRef()),
      (this._specialistsjukskoterskaSectionRef = React.createRef()),
      (this._specialistkompetensSectionRef = React.createRef()),
      (this._betalningSectionRef = React.createRef()),
      (this._utbildningSectionRef = React.createRef()),
      (this._dokumentSectionRef = React.createRef()),
      (this._personuppgifterSectionRef = React.createRef()),
      (this._granskningAvUtbildningSectionRef = React.createRef()),
    ];

    this._documentFetcherParams = {
      formType: props.typeOfAnsokan,
      yrke: props.predefinedYrke,
      worked3yearsInEU: props.hasWorked3YearsInEUEES,
      isSpecialistsjukskoterska:
        props.typeOfAnsokan === TypeOfAnsokan.Specialistkompetens && props.predefinedYrke === Yrke.Sjukskoterska,
      hasSpecialistkompetens:
        props.typeOfAnsokan === TypeOfAnsokan.Specialistkompetens && props.predefinedYrke !== Yrke.Sjukskoterska,
      hasDoubleSpecialistkompetens: false,
    };
    this._isSpecialistClicked = false;
    this._documentFetcher = new DocumentFetcher(Translate, false, props.openWebAnsokanInfoBubbles, null);

    const isOutsideEuEesFlow =
      props.outSideEuEesType === OutSideEuEesType.Assessment ||
      props.outSideEuEesType === OutSideEuEesType.OutsideEuEes;
    const documents = isOutsideEuEesFlow
      ? this._documentFetcher.getOutsideEuEesModels(props.outSideEuEesType, props.predefinedYrke)
      : this._documentFetcher.getModels(this._documentFetcherParams);

    let specialistCostInformation = null;
    if (props.typeOfAnsokan === TypeOfAnsokan.Specialistkompetens) {
      specialistCostInformation = props.openWebAnsokanEpiTexts.SpecialistkompetensBody;
      if (props.predefinedYrke === Yrke.Sjukskoterska)
        specialistCostInformation = props.openWebAnsokanEpiTexts.SpecialistsjukskoterskaBody;
      else if (props.predefinedYrke === Yrke.Tandlakare)
        specialistCostInformation = props.openWebAnsokanEpiTexts.SpecialistkompetensTandlakareBody;
    }

    this.state = {
      formData: new Map<string, string>(),
      activeYrke: props.predefinedYrke || null,
      hasErrors: false,
      documents,
      specialistCostInformation,
      isErrorDialogOpen: false,
      samtycker: false,
      showSpinner: false,
      isFormDirty: false,
    };
  }

  componentDidMount = () => {
    this.validateAllSections(false);
    window.onbeforeunload = () => {
      if (this.state.isFormDirty) {
        return 'Är du säker på att du vill lämna sidan?';
      }
    };
  };

  componentWillUnmount = () => {
    window.onbeforeunload = null;
  };

  validateAllSections = (setAsDirty: boolean = true) => {
    const { samtycker } = this.state;
    let allFieldsValid = samtycker ? true : false;
    this._sectionRefList.forEach((section) => {
      if (section.current?.hasErrors()) {
        allFieldsValid = false;
      }
    });
    this.setState({
      hasErrors: !allFieldsValid,
      isFormDirty: setAsDirty,
    });
  };

  componentDidUpdate() {
    this._isSpecialistClicked = false;
  }

  onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    this.setState({ submitButtonIsClicked: true });
    let formData = new FormData(this._formRef.current as any);

    const removeKeys = [];
    formData.forEach((value, key, parent) => {
      if (key.startsWith('doc_')) {
        removeKeys.push(key);
      }
    });
    removeKeys.forEach((x) => formData.delete(x));

    const documents = _.cloneDeep(this.state.documents);

    documents.forEach((x) => {
      if (x.files == null || x.files.length < 1) {
        formData.append(x.fieldName, null);
      } else {
        x.files.forEach((y) => {
          formData.append(x.fieldName, y.file);
        });
      }
    });

    let partialState = { isErrorDialogOpen: false, apiLogId: null } as IPublicFormState;

    if (!this.state.hasErrors) {
      this.setState({ showSpinner: true });
      this.props.googleReCaptchaProps.executeRecaptcha('legitimation_form').then(
        (token) => {
          formData.append(CaptchaFieldName, token);
          formData.append(MailTypeFieldName, MailType.Legitimation.toString());

          doPost<string>('/_api/ansokanform/skicka/', formData)
            .then(
              (res) => {
                if (res instanceof ResponseError) {
                  partialState.isErrorDialogOpen = true;
                  partialState.apiLogId = res.body.errorMessage;
                  partialState.showSpinner = false;
                } else {
                  this.setState({ isFormDirty: false });
                  window.location.href = this.props.redirectPage;
                }
              },
              (rejectReason) => {
                partialState.isErrorDialogOpen = true;
                partialState.showSpinner = false;
              },
            )
            .then((_) => {
              this.setState(partialState);
            });
        },
        (rejection) => {
          console.log(rejection);
        },
      );
    }
  };

  get yrkeSelectBoxOption(): SelectBoxOption[] {
    return this.props.yrkeKostnader.map((yrkeKostnad) => {
      return { key: yrkeKostnad.Yrke, text: Translate(`yrke_${yrkeKostnad.Yrke}`) };
    });
  }

  get yrkesKostnad(): number {
    return this.props.yrkeKostnader.find((x) => x.Yrke === this.state.activeYrke)?.Kostnad;
  }

  getSamtyckeErrorMessage = (): string => {
    if (this.state.submitButtonIsClicked && !this.state.samtycker) {
      return Translate('error_mandatory');
    }
    return '';
  };

  onChangeSpecialist = (isSpecialist: boolean, isDoubleSpecialist = false) => {
    const { activeYrke } = this.state;
    const { openWebAnsokanEpiTexts } = this.props;
    this.resetSpecialistFlags();
    let specialistCostInformation = null;

    // Set new correct flags
    if (activeYrke === Yrke.Sjukskoterska) {
      this._documentFetcherParams.isSpecialistsjukskoterska = isSpecialist;
    } else {
      this._documentFetcherParams.hasSpecialistkompetens = isSpecialist;
      this._documentFetcherParams.hasDoubleSpecialistkompetens = isDoubleSpecialist;
    }

    if (isSpecialist) {
      if (activeYrke === Yrke.Sjukskoterska) {
        specialistCostInformation = openWebAnsokanEpiTexts.SpecialistsjukskoterskaBody;
      } else if (activeYrke === Yrke.Tandlakare) {
        specialistCostInformation = openWebAnsokanEpiTexts.SpecialistkompetensTandlakareBody;
      } else {
        specialistCostInformation = openWebAnsokanEpiTexts.SpecialistkompetensBody;
      }
    }

    const documents = this._documentFetcher.getModels(this._documentFetcherParams);
    documents.forEach((doc) => {
      let oldDoc = this.state.documents.find((x) => x.fieldName === doc.fieldName);
      if (oldDoc?.files?.length > 0) {
        doc.files = _.cloneDeep(oldDoc.files);
      }
    });

    const isFormDirty = true;
    this._isSpecialistClicked = isSpecialist;
    // Update state with new documents
    this.setState({
      documents,
      specialistCostInformation,
      isFormDirty,
    });
  };

  resetSpecialistFlags = () => {
    this._documentFetcherParams.isSpecialistsjukskoterska = false;
    this._documentFetcherParams.hasSpecialistkompetens = false;
    this._documentFetcherParams.hasDoubleSpecialistkompetens = false;
  };

  fileInputChanged = (files: FormFieldFile) => {
    const documents = _.cloneDeep(this.state.documents);

    const document = documents.find((doc) => doc.fieldName === files.fieldName);
    if (document) {
      const filesArr = files.value;
      filesArr.forEach((file) => {
        file.status = file.status === FileState.UPLOADING ? FileState.SETTLED : file.status;
        file.FileId = shortuid();
      });
      document.files = filesArr;
    }

    this.setState({ documents });
  };

  onChangeYrke = (yrke: Yrke, callback: () => void) => {
    // Setting activeYrke to null first in order to reset sections
    this.setState(
      {
        activeYrke: null,
      },
      () => {
        this.resetSpecialistFlags();
        this._documentFetcherParams.yrke = yrke;
        this.setState(
          {
            activeYrke: yrke,
            documents: this._documentFetcher.getModels(this._documentFetcherParams),
            specialistCostInformation: null,
          },
          callback,
        );
      },
    );
  };

  onModalClose = () => {
    this.setState({
      isErrorDialogOpen: false,
      apiLogId: null,
    });
  };

  onSamtyckeCheck = (field: FormField<boolean>) => {
    this.setState({ samtycker: field.value, isFormDirty: true }, () => {
      this.validateAllSections();
    });
  };

  public render() {
    const {
      heading,
      typeOfAnsokan,
      isInEditMode,
      openWebAnsokanEpiTexts,
      contentId,
      openWebAnsokanInfoBubbles,
      maxTotalSizeInBytes,
      predefinedYrke,
      maxIndividualFileSizeInBytes,
      formLanguage,
      countryList,
      outSideEuEesType,
    } = this.props;
    const {
      activeYrke,
      documents,
      specialistCostInformation,
      isErrorDialogOpen,
      apiLogId,
      samtycker,
      hasErrors,
      showSpinner,
      submitButtonIsClicked,
    } = this.state;

    const isOutsideEuEesFlow =
      outSideEuEesType === OutSideEuEesType.Assessment || outSideEuEesType === OutSideEuEesType.OutsideEuEes;

    return (
      <>
        {isErrorDialogOpen && (
          <DialogueError
            dialogueErrorBody={getDialogueByResponse(apiLogId)}
            isModalOpen={isErrorDialogOpen}
            onModalClose={this.onModalClose}
            enableCloseIcon={true}
            shouldCloseOnOverlayClick={false}
          />
        )}

        <EpiserverProperty propertyName="Heading" isInEditMode={isInEditMode}>
          <h1>{heading}</h1>
        </EpiserverProperty>

        <EpiserverProperty
          propertyName="Preamble"
          wrappingElement="span"
          isInEditMode={isInEditMode}
          usingDangerouslySetInnerHTML={true}>
          <p className="preamble" dangerouslySetInnerHTML={setInnerHtml(openWebAnsokanEpiTexts.Preamble)}></p>
        </EpiserverProperty>

        <form ref={this._formRef} noValidate method="post" id="leg-public-form" onSubmit={this.onSubmit}>
          <input type="hidden" name={ContentIdFieldName} value={contentId} />
          <input type="hidden" name={LanguageFIeldName} value={formLanguage} />
          {outSideEuEesType != null && (
            <input type="hidden" name={OutsideEuEesTypeFieldName} value={outSideEuEesType.toString()} />
          )}
          {predefinedYrke && <input type="hidden" name={FieldName.Yrke} value={predefinedYrke} />}
          <AttentionBox
            bodytext={Translate('varning_lamnasidan')}
            cssClass="attentionbox--brown m-b-2 m-t-2"
            icon="Infocirkel"
          />
          {typeOfAnsokan === TypeOfAnsokan.Legitimation && !predefinedYrke && (
            <YrkeSection
              ref={this._yrkeSectionRef}
              Translate={Translate}
              onChangeFieldValue={this.validateAllSections}
              onChangeYrke={this.onChangeYrke}
              yrken={this.yrkeSelectBoxOption}
              submitButtonIsClicked={this.state.submitButtonIsClicked}
              formType={FormType.Legitimation}
            />
          )}

          {(isInEditMode || activeYrke || isOutsideEuEesFlow) && (
            <>
              {(isInEditMode || BUSINESS_RULES.specialistsjukskoterskaEnabled.get(activeYrke)) &&
                !isOutsideEuEesFlow && (
                  <SpecialistsjukskoterskaSection
                    ref={this._specialistsjukskoterskaSectionRef}
                    onChangeSpecialist={this.onChangeSpecialist}
                    isInEditMode={isInEditMode}
                    onChangeFieldValue={this.validateAllSections}
                    Translate={Translate}
                    typeOfAnsokan={typeOfAnsokan}
                    openWebAnsokanEpiTexts={openWebAnsokanEpiTexts}
                    formLanguage={formLanguage}
                    submitButtonIsClicked={this.state.submitButtonIsClicked}
                    formType={FormType.Legitimation}
                  />
                )}
              {(isInEditMode || BUSINESS_RULES.specialistkompetensEnabled.get(activeYrke)) && !isOutsideEuEesFlow && (
                <SpecialistkompetensSection
                  ref={this._specialistkompetensSectionRef}
                  onChangeSpecialist={this.onChangeSpecialist}
                  isInEditMode={isInEditMode}
                  openWebAnsokanEpiTexts={openWebAnsokanEpiTexts}
                  onChangeFieldValue={this.validateAllSections}
                  Translate={Translate}
                  typeOfAnsokan={typeOfAnsokan}
                  showAddMoreButton={activeYrke === Yrke.Lakare}
                  activeYrke={activeYrke}
                  formLanguage={formLanguage}
                  submitButtonIsClicked={this.state.submitButtonIsClicked}
                  formType={FormType.Legitimation}
                  hasWorked3YearsInEUEES={this.props.hasWorked3YearsInEUEES}
                  countryList={countryList}
                />
              )}

              <BetalningSection
                activeYrke={activeYrke}
                isOutsideEuEes={outSideEuEesType === OutSideEuEesType.OutsideEuEes}
                isAssessment={outSideEuEesType === OutSideEuEesType.Assessment}
                ref={this._betalningSectionRef}
                isInEditMode={isInEditMode}
                openWebAnsokanEpiTexts={openWebAnsokanEpiTexts}
                onChangeFieldValue={this.validateAllSections}
                Translate={Translate}
                kostnad={this.yrkesKostnad}
                specialistCostInformation={specialistCostInformation}
                submitButtonIsClicked={this.state.submitButtonIsClicked}
                formType={FormType.Legitimation}
              />

              {this.props.typeOfAnsokan !== TypeOfAnsokan.Specialistkompetens && !isOutsideEuEesFlow && (
                <UtbildningSection
                  ref={this._utbildningSectionRef}
                  isInEditMode={isInEditMode}
                  openWebAnsokanEpiTexts={openWebAnsokanEpiTexts}
                  openWebAnsokanInfoBubbles={openWebAnsokanInfoBubbles}
                  onChangeFieldValue={this.validateAllSections}
                  Translate={Translate}
                  formLanguage={formLanguage}
                  submitButtonIsClicked={this.state.submitButtonIsClicked}
                  formType={FormType.Legitimation}
                  outSideEuEes={this.props.hasWorked3YearsInEUEES}
                  countryList={countryList}
                />
              )}
              {isOutsideEuEesFlow && (
                <GranskningAvUtbildningSection
                  ref={this._granskningAvUtbildningSectionRef}
                  isInEditMode={isInEditMode}
                  isAssessment={outSideEuEesType === OutSideEuEesType.Assessment}
                  openWebAnsokanEpiTexts={openWebAnsokanEpiTexts}
                  onChangeFieldValue={this.validateAllSections}
                  Translate={Translate}
                  formLanguage={formLanguage}
                  submitButtonIsClicked={this.state.submitButtonIsClicked}
                  formType={FormType.Legitimation}
                />
              )}
              <DokumentSection
                ref={this._dokumentSectionRef}
                hideOriginalDocumentsCheckbox={outSideEuEesType === OutSideEuEesType.OutsideEuEes}
                isInEditMode={isInEditMode}
                openWebAnsokanEpiTexts={openWebAnsokanEpiTexts}
                documents={documents}
                onChangeFieldValue={this.validateAllSections}
                fileInputChanged={this.fileInputChanged}
                Translate={Translate}
                maxTotalSizeInBytes={maxTotalSizeInBytes}
                maxIndividualFileSizeInBytes={maxIndividualFileSizeInBytes}
                submitButtonIsClicked={this.state.submitButtonIsClicked}
                formType={FormType.Legitimation}
                acceptedFileTypes={this.props.acceptedFileTypes}
                specialistClicked={this._isSpecialistClicked}
              />

              <PersonuppgifterSection
                ref={this._personuppgifterSectionRef}
                isInEditMode={isInEditMode}
                openWebAnsokanEpiTexts={openWebAnsokanEpiTexts}
                onChangeFieldValue={this.validateAllSections}
                Translate={Translate}
                formLanguage={formLanguage}
                submitButtonIsClicked={this.state.submitButtonIsClicked}
                formType={FormType.Legitimation}
                isOutsideEuEesLessThanThreeYears={isOutsideEuEesFlow}
              />

              {isInEditMode && (
                <div className="form-group-xs-small flex">
                  <input className="m-r-1" type="checkbox" />
                  <EpiserverProperty propertyName="SamtyckeLabel" isInEditMode={isInEditMode}>
                    <div className="like-a-label">{openWebAnsokanEpiTexts.SamtyckeLabel}</div>
                  </EpiserverProperty>
                </div>
              )}
              {!isInEditMode && (
                <CheckBox
                  fieldName={FieldName.Samtycke}
                  stringValue={Translate('ja')}
                  errorMessage={this.getSamtyckeErrorMessage()}
                  onChange={this.onSamtyckeCheck}
                  label={openWebAnsokanEpiTexts.SamtyckeLabel}
                />
              )}

              <EpiserverProperty
                propertyName="ReadmorePersonuppgifter"
                usingDangerouslySetInnerHTML={true}
                isInEditMode={isInEditMode}>
                <div dangerouslySetInnerHTML={setInnerHtml(openWebAnsokanEpiTexts.ReadmorePersonuppgifter)} />
              </EpiserverProperty>

              <div className="m-b-4 m-t-2">
                <div className="form-submit">
                  <button className="button relative" type="submit" disabled={showSpinner}>
                    {Translate('skickain')}
                    {showSpinner && <LoadingSpinner cssClasses="button-spinner" />}
                  </button>
                  {submitButtonIsClicked && hasErrors && (
                    <InputError id={this._errorId} errorText={Translate('error_missing_fields')} />
                  )}
                </div>
              </div>
            </>
          )}
        </form>
      </>
    );
  }
}
